"use strict";
/**
 * AngularJS components.
 *
 * @packageDocumentation
 * @module Components
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#region Angular Imports
var angular_1 = tslib_1.__importDefault(require("angular"));
//#endregion
//#region Module Imports
var button_1 = require("./button");
var button_list_1 = require("./button-list");
var popup_1 = require("./button-list/popup");
var popover_1 = require("./button-list/popover");
var popover_with_button_1 = require("./button-list/popover-with-button");
var fullscreen_container_1 = require("./fullscreen-container");
var icon_1 = require("./icon");
var loading_container_1 = require("./loading-container");
var popup_2 = require("./overlay/popup");
var popover_2 = require("./overlay/popover");
var tag_box_1 = require("./tag-box");
var toolbar_1 = require("./toolbar");
//#endregion
//#region Module Setup
exports.MODULE_NAME = 'imr.controls.components';
angular_1.default.module(exports.MODULE_NAME, [
    button_1.BUTTON_MODULE_NAME,
    button_list_1.BUTTON_LIST_MODULE_NAME,
    popup_1.BUTTON_LIST_POPUP_MODULE_NAME,
    popover_1.BUTTON_LIST_POPOVER_MODULE_NAME,
    popover_with_button_1.BUTTON_LIST_POPOVER_WITH_BUTTON_MODULE_NAME,
    fullscreen_container_1.FULLSCREEN_CONTAINER_MODULE_NAME,
    icon_1.ICON_MODULE_NAME,
    loading_container_1.LOADING_CONTAINER_MODULE_NAME,
    popup_2.POPUP_MODULE_NAME,
    popover_2.POPOVER_MODULE_NAME,
    tag_box_1.TAG_BOX_MODULE_NAME,
    toolbar_1.TOOLBAR_MODULE_NAME
]);
//#endregion
//# sourceMappingURL=components.module.js.map